<div class="step-panel step-panel-compact step-panel-info-general">
  <h3>Informacion general</h3>
  <p class="step-intro">Completa los antecedentes base del programa y del proyecto. Los campos marcados con * son obligatorios.</p>

  <div class="info-banner">
    Mantendremos una estructura consistente entre concursos. Si ya existen datos en Mi perfil, algunos campos como institucion, region, correo o telefono pueden llegar precargados y seguiran siendo editables.
  </div>

  <div class="section-block">
    <h4>Programa de estudios</h4>
    <div class="form-grid">
      <label class="field">
        <span>Nombre de la institucion (*)</span>
        <input type="text" [(ngModel)]="formulario.nombreInstitucion" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Nombre del programa de estudios (*)</span>
        <input type="text" [(ngModel)]="formulario.nombreProgramaEstudios" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Region en que se imparte (*)</span>
        <input type="text" [(ngModel)]="formulario.regionProgramaEstudios" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Especialidad Web of Science (WOS) (*)</span>
        <input type="text" [(ngModel)]="formulario.especialidadWos" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Sub area OCDE (*)</span>
        <input type="text" [(ngModel)]="formulario.subAreaOcde" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Fecha de inicio de estudios (*)</span>
        <input type="date" [(ngModel)]="formulario.fechaInicioEstudios" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>
    </div>
  </div>

  <div class="section-block">
    <h4>Direccion web y contacto</h4>
    <div class="form-grid">
      <label class="field">
        <span>Sitio web de la universidad</span>
        <input type="url" [(ngModel)]="formulario.sitioWebUniversidad" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Sitio web del programa</span>
        <input type="url" [(ngModel)]="formulario.sitioWebPrograma" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Estado de la postulacion (*)</span>
        <select [(ngModel)]="formulario.estadoProgramaEstudios" (ngModelChange)="registrarCambio()" [disabled]="soloLectura">
          <option value="">Seleccione</option>
          <option value="postulado">Postulado</option>
          <option value="admitido">Admitido</option>
          <option value="matriculado">Matriculado</option>
        </select>
      </label>

      <label class="field">
        <span>Correo de contacto</span>
        <input type="email" [(ngModel)]="formulario.correoContacto" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Telefono de contacto</span>
        <input type="text" [(ngModel)]="formulario.telefonoContacto" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>
    </div>
  </div>

  <div class="section-block" *ngIf="mostrarSeccionProyecto; else seccionBecaTpl">
    <h4>Base del proyecto</h4>
    <div class="form-grid">
      <label class="field field-full">
        <span>Titulo del proyecto (*)</span>
        <input type="text" [(ngModel)]="formulario.nombreProyecto" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field field-full">
        <span>Resumen del proyecto (*)</span>
        <textarea rows="4" [(ngModel)]="formulario.resumenProyecto" (ngModelChange)="registrarCambio()" [disabled]="soloLectura"></textarea>
      </label>

      <label class="field field-full">
        <span>Objetivo general (*)</span>
        <textarea rows="3" [(ngModel)]="formulario.objetivoGeneral" (ngModelChange)="registrarCambio()" [disabled]="soloLectura"></textarea>
      </label>

      <label class="field">
        <span>Linea de investigacion</span>
        <input type="text" [(ngModel)]="formulario.lineaInvestigacion" (ngModelChange)="registrarCambio()" [disabled]="soloLectura" />
      </label>

      <label class="field">
        <span>Duraci&oacute;n del proyecto en a&ntilde;os (*)</span>
        <select [(ngModel)]="formulario.duracionPresupuestoAnios" (ngModelChange)="registrarCambio()" [disabled]="soloLectura">
          <option *ngFor="let anios of opcionesDuracionProyecto" [ngValue]="anios">{{ anios }}</option>
        </select>
      </label>
    </div>
  </div>

  <ng-template #seccionBecaTpl>
    <div class="placeholder-box">
      <strong>Concurso tipo beca:</strong> esta postulacion prioriza programa de estudios y antecedentes del postulante, por lo que el desarrollo del proyecto queda simplificado.
    </div>
  </ng-template>
</div>
